module.exports = __webpack_public_path__ + "img/pic2.756af6ab.png";